<!-- Modal to edit a planning -->
<template>
<div class="card modal-card" style="width: auto; overflow:visible;">
    <header class="card-header modal-card-header-title">
        <div class="card-header-title modal-card-header-title">
            <p class="card-title modal-card-title">{{$t('PlanningModal.title')}}&nbsp;{{name}}</p>
        </div>
        <a @click="$parent.close()" class="card-header-icon" aria-label="more options">
            <b-icon icon="close" type="is-white"></b-icon>
        </a>
    </header>
    <section class="card-content">
        <div class="columns is-centered">
            <div class="column is-12">
                <b-field :label="$t('PlanningModal.input_planningname')" :type="{'is-danger': errors.has('name')}" :message="errors.first('name')">
                    <b-input required v-model="name" maxlength="30" v-validate="'required'" name="name" :placeholder="$t('PlanningModal.input_planningname_placeholder')"></b-input>
                </b-field>
            </div>
        </div>
        <div class="columns is-centered">
            <div class="column is-6">
                <b-field :label="$t('PlanningModal.input_start')">
                    <b-datepicker required class="is-small" :placeholder="$t('PlanningModal.input_start_placeholder')" icon="calendar-today" v-model="startDate" :min-date="FIRST_DAY_YEAR" :max-date="maxDate"></b-datepicker>
                </b-field>
            </div>
            <div class="column is-6">
                <b-field :label="$t('PlanningModal.input_end')">
                    <b-datepicker class="is-small" required :placeholder="$t('PlanningModal.input_end_placeholder')" icon="calendar-today" v-model="endDate" :min-date="minDate" :max-date="LAST_DAY_YEAR"></b-datepicker>
                </b-field>
            </div>
        </div>
        <div class="columns is-centered">
            <div class="column is-12">
                <b-field :label="$t('PlanningModal.checkbox_fixOverlapping')" :type="{'is-danger': errors.has('name')}" :message="errors.first('name')">
                    <b-checkbox v-model="fixOverlapping"></b-checkbox>
                </b-field>
            </div>
        </div>
    </section>
    <footer class="card-footer">
        <div class="card-footer-item">
            <button class="button is-danger" @click="deletePlanning()">{{$t('PlanningModal.action_delete')}}</button>&nbsp;
            <button class="button is-primary" @click="update()">{{$t('PlanningModal.action_save')}}</button>&nbsp;
            <button class="button is-primary" @click="duplicate()" :disabled="!isDuplicating" >{{$t('PlanningModal.action_duplicate')}}</button>
        </div>
    </footer>
</div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PlanningModal',
  data: function () {
    return {
      /** Const */
      LAST_DAY_YEAR: new Date(new Date().getFullYear(), 11, 31),
      FIRST_DAY_YEAR: new Date(new Date().getFullYear(), 0, 1),

      name: this.planningName,
      startDate: moment()
        .dayOfYear(this.startDayInYear)
        .toDate(),
      endDate: moment()
        .dayOfYear(this.endDayInYear)
        .toDate(),
      fixOverlapping: false
    }
  },
  props: {
    planningId: {
      type: Number,
      required: true
    },
    planningName: {
      type: String,
      required: true
    },
    startDayInYear: {
      type: Number,
      required: true
    },
    endDayInYear: {
      type: Number,
      required: true
    }
  },

  computed: {
    minDate: function () {
      return this.startDate
    },
    maxDate: function () {
      return this.endDate
    },
    isDuplicating () {
      return this.startDayInYear !== moment(this.startDate).dayOfYear() || this.endDayInYear !== moment(this.endDate).dayOfYear()
    }
  },

  methods: {
    update: function () {
      this.$validator.validate().then(valid => {
        if (valid) {
          /** *Create event to save planning */
          const planning = {}
          planning.id = this.planningId
          planning.name = this.name
          planning.startDayInYear = moment(this.startDate).dayOfYear()
          planning.endDayInYear = moment(this.endDate).dayOfYear()
          planning.fixOverlapping = this.fixOverlapping

          this.$store.dispatch('planning/updatePlanning', planning)
          this.$parent.close()
        }
      })
    },
    deletePlanning: function () {
      this.$store.dispatch('planning/deletePlanning', this.planningId)
      this.$parent.close()
    },
    duplicate () {
      this.$validator.validate().then(valid => {
        if (valid) {
          const planning = {}
          planning.id = this.planningId
          planning.name = this.name
          planning.startDayInYear = moment(this.startDate).dayOfYear()
          planning.endDayInYear = moment(this.endDate).dayOfYear()
          planning.fixOverlapping = this.fixOverlapping
          this.$store.dispatch('planning/duplicatePlanning', planning)
          this.$parent.close()
        }
      })
    }
  }
}
</script>

<style>
.card-header {
    background-color: #448993;
}

.modal-content {
    overflow: unset !important;
}

.modal-card-header-title {
    border-radius: 3px 3px 0px 0px !important;
}

.modal-card-title {
    color: white !important;
    font-size: 20px !important;
    font-weight: initial !important;
}

.modal-card {
    width: auto;
    border-radius: 3px !important;
}

.modal .modal-content {
    width: 640px;
}
</style>
